// Shared branding footer. Fixed 5vh above the viewport bottom on app shells;
// pass static so it sits in document flow instead.
import React from "react";

export const FOOTER_HEIGHT = 54;

export default function AdminFooter({ static: isStatic = false, showAdminLink = false, onAdmin }) {
  return (
    <footer
      style={{
        ...(isStatic
          ? { position: "static" }
          : { position: "fixed", left: 0, right: 0, bottom: "5vh", zIndex: 40 }),
        width: "100%",
        boxSizing: "border-box",
        borderTop: "1px solid var(--ink)",
        background: "var(--bg)",
        padding: "16px clamp(14px, 3vw, 40px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: "clamp(12px, 3vw, 28px)",
        textAlign: "center",
        font: "500 clamp(9px, 1.1vw, 11px)/1.45 var(--bq-font-display)",
        letterSpacing: ".04em",
        color: "var(--muted2)",
        textTransform: "uppercase",
      }}
    >
      <span>Copyright boardIQ 2026, All Rights Reserved. SDOMUS LLC, Milpitas CA</span>
      {showAdminLink && (
        <a
          href="#/admin"
          onClick={onAdmin}
          style={{
            color: "var(--accentDeep)",
            textDecoration: "none",
            fontWeight: 600,
            letterSpacing: ".1em",
            textTransform: "uppercase",
            borderBottom: "1px solid var(--accentDeep)",
            paddingBottom: 1,
          }}
        >
          Admin
        </a>
      )}
    </footer>
  );
}
